import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { ChakraBox as Box } from "@airhelp/react-ui-components";

const OlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ol" sx={styles}>
    {children}
  </Box>
);

export default OlList;
